import { render } from "./Part_Form.vue?vue&type=template&id=10b97b92&scoped=true"
import script from "./Part_Form.vue?vue&type=script&lang=js"
export * from "./Part_Form.vue?vue&type=script&lang=js"

import "./Part_Form.vue?vue&type=style&index=0&id=10b97b92&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\vue\\portfolio-test\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10b97b92"]])

export default __exports__